import React, { useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { addSellingSource } from "../publicationSlice";
import { validateFullName, startsWithSpace } from "../../../Utils/validators";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";
const CreateSellingSource = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [sourceName, setSourceName] = useState<string>("");
  const onChangeSellingSource = (value: string) => {
    if (validateFullName(value) && !startsWithSpace(value)) {
      setSourceName(value);
    }
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    const postData = {
      name: sourceName,
    };
    dispatch(
      addSellingSource({
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            setSourceName("");
            dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.status }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };
  const validations = (): boolean => {
    return sourceName === "";
  };

  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Add Selling Source"}
          breadCrumb={""}
          isEditMode={""}
          cancelEdit={() => ""}
        />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4">
          <form onSubmit={handleSubmit}>
            <div className="row align-items-center">
              <div className="col-md-6 mb-3">
                <LabelInput labelName={"Selling Source Name"} />
                <div className="d-flex align-items-center">
                  <div className="me-3 col-md-8">
                    <InputField
                      key={"ex2"}
                      placeholder={"Enter Selling Source Name"}
                      setInputText={(value: any) => onChangeSellingSource(value)}
                      value={sourceName}
                    />
                  </div>
                  <div className="col-2">
                    <Submitbtn name={"Add "} disabled={validations()} />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateSellingSource;
